// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { TransferPreapproval } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/TransferPreapproval';
import { ERR_WITHDRAW_PREAPPROVAL, SUC_WITHDRAW_PREAPPROVAL } from '../../../../utils/strings';

export const useWithdrawTransferPreapproval = () => {
  const { submit } = useExerciseSubmission(
    TransferPreapproval.TransferPreapproval_Withdraw,
    SUC_WITHDRAW_PREAPPROVAL,
    ERR_WITHDRAW_PREAPPROVAL,
  );
  return submit;
};
